export default __webpack_public_path__ + "static/media/Anirudha Joshi.6dc0ff8f.jpg";